export default __webpack_public_path__ + "static/startupchile-0f8f091107f5580dfe0fd8d9ed553f03.png";